// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class GLSubmission extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(255) */
  confirmationKey?: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(30) */
  entityId!: string;
  /** String */
  errorMessage?: string;
  /** DateTimeOffset */
  submissionTs?: Date;
  /** String(50) */
  tableName!: string;
  /** Boolean */
  wasPreviouslySubmitted!: boolean;
}

